module.exports = __webpack_public_path__ + "assets/img/order-icon3.b5066c4e.png";